import { NOTIFICATION_TYPE } from '../../../../constants/common'
import i18n from '../../../../i18n'
import { DocFlowMappingProcessCell } from '../../DocFlowMapping'

import {
  DOC_FLOW_MAPPING_WIDGET_RESULT_ERROR_NOTIFICATION_ID,
  DOC_FLOW_MAPPING_WIDGET_RESULT_HAS_DUPLICATES_NOTIFICATION_ID,
  DOC_FLOW_MAPPING_WIDGET_RESULT_SUCCESS_NOTIFICATION_ID,
  DocFlowMappingWidgetResultNotificationType,
} from './DocFlowMappingWidgetResult.constants'

export function getWidgetResultItems({ documents, users }) {
  return [
    {
      text: users,
      title: i18n.t('DocumentStapling.ResultWidgetMappedUsersTitleKey'),
    },
    {
      text: documents,
      title: i18n.t('DocumentStapling.ResultWidgetSplittedDocumentsTitleKey'),
    },
  ]
}

export function isWidgetError({ isResultActive, processData }) {
  return (
    !processData?.[DocFlowMappingProcessCell.ResultMappedUsers] &&
    isResultActive
  )
}

export function getWidgetResultNotifications(t) {
  return {
    [DocFlowMappingWidgetResultNotificationType.Error]: {
      id: DOC_FLOW_MAPPING_WIDGET_RESULT_ERROR_NOTIFICATION_ID,
      text: t('DocumentStapling.MappingResultWidgetErrorNotificationTitleKey'),
      type: NOTIFICATION_TYPE.error,
    },
    [DocFlowMappingWidgetResultNotificationType.HasDuplicates]: {
      id: DOC_FLOW_MAPPING_WIDGET_RESULT_HAS_DUPLICATES_NOTIFICATION_ID,
      text: t(
        'DocumentStapling.MappingResultWidgetHasDuplicatesNotificationTitleKey'
      ),
      type: NOTIFICATION_TYPE.warning,
    },
    [DocFlowMappingWidgetResultNotificationType.Success]: {
      id: DOC_FLOW_MAPPING_WIDGET_RESULT_SUCCESS_NOTIFICATION_ID,
      text: t(
        'DocumentStapling.MappingResultWidgetSuccessNotificationTitleKey'
      ),
      type: NOTIFICATION_TYPE.success,
    },
  }
}
